import quillWordcountModule from '../../packages/quill-wordcount-module/src';

/**
 * Registers the wordcount module with Quill.
 *
 * @since 6.10.0
 */
( function() {
	quillWordcountModule();
}() );
